export default "__VITE_ASSET__SYUznZ05__"